import {
  SET_GEOFENCES_NAME,
  SET_GEOFENCES_VISIBILITY_OPTIONS,
  SET_GEOFENCES_SIDEWALKS_EDIT_MODE,
  ADD_GEOFENCES_LAYER,
  SET_GEOFENCES_LAYERS,
  SET_GEOFENCES_SELECTED_LAYER,
  SET_GEOFENCES_SELECTED_ZONE,
  SET_SCHEDULED_RULES,
  INIT_GEOFENCES_DATA,
  SET_GEOFENCES_ERROR,
  SET_GEOFENCES_KEY,
  DELETE_SCHEDULE_RULE,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case SET_GEOFENCES_NAME:
      return {
        ...state,
        name: action.payload,
      };
    case SET_GEOFENCES_VISIBILITY_OPTIONS: {
      const { showPolygons, showHexes } = action.payload;

      return {
        ...state,
        showPolygons,
        showHexes,
      };
    }
    case SET_GEOFENCES_SIDEWALKS_EDIT_MODE:
      return {
        ...state,
        sidewalksEditMode: action.payload.mode,
      };
    case SET_SCHEDULED_RULES:
      return {
        ...state,
        scheduledRules: action.payload,
      };
    case ADD_GEOFENCES_LAYER:
      return {
        ...state,
        layers: {
          ...state.layers,
          [action.payload.key]: action.payload,
        },
      };
    case SET_GEOFENCES_LAYERS:
      return {
        ...state,
        layers: action.payload,
      };
    case SET_GEOFENCES_SELECTED_LAYER:
      return {
        ...state,
        selectedLayer: action.payload || {},
        selectedZone: {},
      };
    case SET_GEOFENCES_SELECTED_ZONE:
      return {
        ...state,
        selectedLayer: {},
        selectedZone: action.payload || {},
      };
    case INIT_GEOFENCES_DATA:
      return {
        ...action.payload,
      };
    case SET_GEOFENCES_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_GEOFENCES_KEY:
      return {
        ...state,
        key: action.payload,
      };
    case DELETE_SCHEDULE_RULE:
      return {
        ...state,
        scheduledRules: state.scheduledRules.filter((rule) => rule.schedule.id !== action.payload),
      };
    default:
      return state;
  }
};
